import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import Search from "@/components/form/search/Search"
import Icon from "@/components/icon/Icon"
import { MetricMeta } from "@/types/metric"
import { useTranslateMetric } from "@/hooks/metric/useTranslateKeyHook"

interface Props {
  metrics: MetricMeta[]
  searchValue: string
  onSearchChange: (value: string) => void
  onSelect: (metricKey: string) => void
  totalCount: number
  disabled?: boolean
}

export default function MetricList({
  metrics,
  searchValue,
  onSearchChange,
  onSelect,
  totalCount,
  disabled = false,
}: Props) {
  const { t } = useTranslation()
  const translateMetric = useTranslateMetric()

  // 검색 필터링 (번역된 이름으로 검색)
  const filteredMetrics = useMemo(() => {
    if (!searchValue || searchValue.length < 2) {
      return metrics
    }
    const searchLower = searchValue.toLowerCase()
    return metrics.filter((metric) => {
      const translatedName = translateMetric(metric)?.toLowerCase() || ""
      return translatedName.includes(searchLower) || metric.key.toLowerCase().includes(searchLower)
    })
  }, [metrics, searchValue, translateMetric])

  return (
    <div className="MetricListCont">
      <div className="list-header">
        <div className="metric-count">
          <span className="section-label">{t("metrics")}</span>
          <span className="count-badge">{totalCount}</span>
        </div>
        <Search onChange={onSearchChange} />
      </div>

      <div className="metric-options">
        {filteredMetrics.length === 0 ? (
          <div className="metric-option disabled">{t("messages.noDataAvailable")}</div>
        ) : (
          filteredMetrics.map((metric) => (
            <div
              key={metric.key}
              className={`metric-option ${disabled ? "disabled" : ""}`}
              onClick={() => !disabled && onSelect(metric.key)}>
              <Icon type="add" className="plus-icon" />
              <span>{translateMetric(metric)}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
